import ReportsDashboard from './ReportsDashboard';

export default ReportsDashboard; 
